export const CLIENT_SECRET_PLACEHOLDER = '**********';
